export default "__VITE_ASSET__C37acTTB__"